export default "__VITE_ASSET__DhGwgg49__"